"use client";

import { HTMLMotionProps, motion } from "framer-motion";
import React, { FC } from "react";

export const MotionAnimate: FC<HTMLMotionProps<"div">> = ({ ...props }) => {
  return <motion.div {...props}>{props.children}</motion.div>;
};
